export const UPDATE_ACTIVITY_FILTER = '[SEARCH] UPDATE_ACTIVITY_FILTER';
export const UPDATE_PLAY_TYPE_FILTER = '[SEARCH] UPDATE_PLAY_TYPE_FILTER';
export const UPDATE_PLAYERS_FILTER = '[SEARCH] UPDATE_PLAYERS_FILTER';
export const UPDATE_MINUTES_FILTER = '[SEARCH] UPDATE_MINUTES_FILTER';
export const UPDATE_MATERIALS_FILTER = '[SEARCH] UPDATE_MATERIALS_FILTER';
export const RESET_FILTERS = '[SEARCH] RESET_FILTERS';

export const updateActivityFilter = (filter) => ({
  type: UPDATE_ACTIVITY_FILTER,
  payload: filter,
});

export const updatePlayTypeFilter = (filter) => ({
  type: UPDATE_PLAY_TYPE_FILTER,
  payload: filter,
});

export const updatePlayersFilter = (filter) => ({
  type: UPDATE_PLAYERS_FILTER,
  payload: filter,
});

export const updateMinutesFilter = (filter) => ({
  type: UPDATE_MINUTES_FILTER,
  payload: filter,
});

export const updateMaterialsFilter = (filter) => ({
  type: UPDATE_MATERIALS_FILTER,
  payload: filter,
});

export const resetFilters = () => ({
  type: RESET_FILTERS,
});
